import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import DataHelper from "@Scripts/Common/DataHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "SingleValueListFilter" })
export default class SingleValueListFilter extends Vue {
    public localizer: any = Localizer;
    public isListVisible: boolean = false;
    public listIndex: number = 5;

    get isContentLoading(): any {
        return this.$store.getters["catalogueStore/isContentLoading"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    get selectedItem() {
        let filter = this.filters.find(x => x.name === this.filterSelector.name);
        if (filter?.value) {
            if (DataHelper.isNumeric(filter.value)) {
                let selectedItem = this.filterSelector.listItems.find(x => x.value === DataHelper.convertToNative(filter.value, this.filterSelector.dataType));
                if (selectedItem) {
                    return selectedItem;
                }
            } else {
                for (const value of filter.value.split(",")) {
                    let selectedItem = this.filterSelector.listItems.find(x => x.value === DataHelper.convertToNative(value, this.filterSelector.dataType));
                    if (selectedItem) {
                        return selectedItem;
                    }
                }
            }
        }
    }

    @Prop() readonly filters: any[];
    @Prop() readonly selectedFilter: string;
    @Prop() readonly filterSelector: any;
    @Prop() readonly page: string;

    public mounted() {
        this.isListVisible = this.selectedFilter === this.filterSelector.name;
    }

    public async setFilter(value: string) {
        this.$emit("setFilter", this.filterSelector.name, DataHelper.convertToString(value, this.filterSelector.dataType));
    }

    public setIsListVisible() {
        this.isListVisible = !this.isListVisible;
    }
};